import axios from 'axios';

export const VENDOR_PRODUCTS_RECEIVED = 'VENDOR_PRODUCTS_RECEIVED';

const getVendorProducts = () => (
  dispatch => (
    axios.get('/api/product-management/vendor-products')
      .then((response) => {
        dispatch({
          type: VENDOR_PRODUCTS_RECEIVED,
          products: response.data.data,
        });

        return response.data.data;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location = '/login';
        }
      })
  )
);

export default getVendorProducts;
